module.exports = __webpack_public_path__ + "static/media/hdgi_nutbolt_with_washer.edac339d.webp";